import PortalNotificationsPanel from '../shared/PortalNotificationsPanel';

export default function ApprenantNotificationsPanel() {
  return <PortalNotificationsPanel portal="apprenant" />;
}
